<template>
    <full-screen-page :icon="icons.warning" color="warning" :title="errorTitle">
        <p class="text-center mb-0 w-full" v-html="message"/>

        <wrapper v-if="statusCode > 399 && statusCode < 500" class="mt-32 mb-24" stretch>
            <btn @click="$router.go(-1)">
                <icon :icon="icons.back"></icon>
                <span>Zurück</span>
            </btn>
        </wrapper>
    </full-screen-page>
</template>

<script>

    import {isString} from "@spoferan/spoferan-ts-core";
	import {backIcon} from "@spoferan/nuxt-spoferan/icons";
	import {warningIcon} from "@spoferan/nuxt-spoferan/icons";

    const errorMessages = {
        "400": {
            "title": "Fehlerhafte Anfrage",
            "message": "Es tut uns leid, aber die Anfrage kann momentan nicht verarbeitet werden. Eventuell liegt das an fehlerhaften Cookies. Bitte lösche Deine Cookies und versuche es noch einmal."
        },
        "401": {
            "title": "Keine Berechtigung",
            "message": "Bitte melde Dich auf SPOFERAN an, um diese Seite aufzurufen."
        },
        "403": {
            "title": "Keine Berechtigung",
            "message": "Leider hast du keine Berechtigung, um diese Seite aufzurufen."
        },
        "404": {
            "title": "Seite nicht gefunden",
            "message": "Die angefragte Seite existiert leider nicht oder du hast nicht die benötigte Berechtigung, diese Seite anzeigen zu lassen."
        },
        "422": {
            "title": "Fehlerhafte Anfrage",
            "message": "Es tut uns leid, aber die Anfrage kann momentan nicht verarbeitet werden. Bitte versuche es später noch einmal."
        },
        "429": {
            "title": "Zu viele Anfragen",
            "message": "Es tut uns leid, aber unser Server ist moment mit zu vielen Anfragen überlastet. Bitte versuche es später noch einmal."
        },
        "500": {
            "title": "Hoppala, da ist etwas schief gelaufen!",
            "message": "Wir wurden bereits benachrichtigt und werden uns direkt darum kümmern. Bitte versuche es also einfach später noch einmal.<br> Sollte dieser Fehler jedoch weiterhin bestehen, kannst du uns auch gerne eine E-Mail an <a href=\"mailto:support@spoferan.com\">support@spoferan.com</a> schreiben. :)"
        },
        "502": {
            "title": "Server nicht erreichbar!",
            "message": "Unser Server scheint gerade nicht erreichbar zu sein. Bitte lade die Seite erneut oder versuche es später noch einmal."
        },
        "503": {
            "title": "Wir sind gleich wieder da!",
            "message": "<p>Wir führen aktuell kleine Wartungsarbeiten durch. Dies bedeutet, dass Dich in Kürze neue Funktionen erwarten.</p><p> Bitte habe ein wenig Geduld und versuche es später noch einmal.</p>"
        },
        "504": {
            "title": "Server nicht erreichbar!",
            "message": "Unser Server scheint gerade nicht erreichbar zu sein. Bitte lade die Seite erneut oder versuche es später noch einmal."
        },
        "private": {
            "title": "Profil nicht aufrufbar",
            "message": "Es tut uns leid, aber dieses Profil ist privat oder existiert nicht."
        }
    };

    export default {
        name: 'NuxtError',

        layout: 'full',

        props: {
            error: {
                type: Object,
                default: null
            }
        },
        head() {
            return {
                title: this.errorTitle,
                meta: [
                    {
                        name: 'viewport',
                        content: 'width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no'
                    }
                ]
            }
        },

		data() {
			return {
				icons: {
					back: backIcon,
					warning: warningIcon,
				}
			}
		},

        computed: {
            statusCode() {
                return (this.error && this.error.statusCode) || 500
            },

            errorTitle() {
                return errorMessages[this.statusCode].title
            },

            message() {
                let showServerMessageResponseCodes = [404, 403];
                if ((this.$config.public.debug === 'true' || this.$config.public.debug === true || showServerMessageResponseCodes.indexOf(this.statusCode) > 0) && this.error.message && isString(this.error.message) && this.error.message !== 'This page could not be found') {
                    return this.error.message;
                }
                return errorMessages[this.statusCode].message
            }
        },

        mounted() {
            this.$nextTick(function () {

                // Timeout to make sure the new route data has been loaded on the '$route' instance, otherwise we would get the path of the referrer route
                setTimeout(() => {
                    if (this.$sentry && this.error.statusCode === 404) {
                        this.$sentry.captureMessage('Page "' + this.$route.path + '" could not be found.');
                    }
                }, 0);

                if (this.error.statusCode === 500
                    && this.canBeFixedByReload()
                    && window.location.hash !== '#retry') {
                    // Mark the page to don't trigger reload infinitely
                    window.location.hash = '#retry';
                    window.location.reload(true)
                }

            });
        },

        methods: {

            /**
             * Checks whether the error does not exist anymore when we reload the page.
             *
             * @returns {boolean}
             */
            canBeFixedByReload() {
                return /^Loading chunk [0-9]+ failed/.test(this.error.message) || /^Maximum call stack size exceeded/.test(this.error.message)
            }
        }
    }
</script>